import styled from "styled-components";

export const StyledDashboard = styled.div`
  margin: 0;
  padding: 0;
  display: grid;
  grid-template-columns: 1fr 1fr;
  width: 100%;
  grid-template-rows: auto minmax(0, 1fr);
  background-color: ${({ theme }) => theme.colors.alabaster};

  @media (max-width: ${({ theme }) => theme.breakPoints.tabletMax}) {
    height: 100%;
  }
`;

export const JiraOverview = styled.div`
  grid-column: span 2;
  display: grid;
  gap: 20px;
  align-items: center;
  grid-template-columns: auto 1fr;
  margin: 10px 30px 0 15px;

    @media (max-width: ${({ theme }) => theme.breakPoints.tabletMax}) {
    grid-template-columns: 1fr;
    font-size: 9px;
    gap: 5px;
  }
`;
